import { combineReducers } from "redux";
import main from "./main";
import questions from "./questions";
import regions from "./regions";

export default combineReducers({
  main,
  questions,
  regions
});
